module.exports = __webpack_public_path__ + "img/pix.0856c56a.png";